import React  , { Component } from 'react'

import { HomeSlider, HomeTitle , FaqItem } from '../../Components/UI/UI'

import {getWeather} from '../../Utility/Utility'
import {  faqDataForPage } from "../../Data/Data";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import './FAQ.css';


class FAQ extends Component {

  state = {
    faq : faqDataForPage, 
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find( (o)=>{
      return o.id === id;
    });
    if ( current.isOpen=== true ) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq : faq
    })

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){

     const faqHtml= this.state.faq.map((o)=>{
    
      return <FaqItem q={o.q} answer={o.answer} isOpen={o.isOpen} click={ () => {
        this.setCurrentFaq(o.id);
      }} />

    });
    return(
      <div className="page align-center page-FAQ inner-page">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <div class="container">
           <HomeTitle>
            FAQ
            </HomeTitle>
            <div className="clear"></div>
            
            <div className="faq-wrapper">
                {faqHtml}
            </div>
            <div className="clear"></div>
        </div>
        <Footer />
      </div>
    )
  }

}



export default FAQ


// WEBPACK FOOTER //
// ./src/Pages/FAQ/FAQ.js